/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function MobileDeviceIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "mobile-device", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("rect", { x: 7.5, y: 4.5, width: 10, height: 16, rx: 2, stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("circle", { cx: 12.5, cy: 17.5, r: 1, stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(MobileDeviceIcon);
export default ForwardRef;
//# sourceMappingURL=mobileDeviceIcon.js.map